export default __webpack_public_path__ + "static/media/image-icon.e18d5fcf.svg";